import moment from 'moment'
import React, { useEffect, useRef, useState } from 'react'
import constant from '../../../../constant'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import Paginations from '../../../common/paginations'
import Print from '../../../../pages/SiteManagement/Print/CustomerPropertyInventory'
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { appendDateRangeToFileName, decodeBase64JsonPayload } from '../../../../utils';
import DeleteFormAction from '../../../common/DeleteFormAction'

// Matches the FORM_CODE written to iship_site_management_form_logs on submit.
const FORM_CODE = 'CPI-001';
const FORM_NAME = 'Customer Property Inventory';

const List = ({ data, setPage, filterPayload, onDeleted }) => {
    const { submissions, page, limit, total } = data
    const printRefs = useRef({});
    const [downloading, setDownloading] = useState(false);
    const parsedFilterPayload = decodeBase64JsonPayload(filterPayload);
    const handleDownload = async (refId, fileName) => {
        const element = printRefs.current[refId];
        if (!element) return;

        const canvas = await html2canvas(element, { scale: 2 });
        const imgData = canvas.toDataURL('image/png');

        const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();

        // Define margins
        const marginTop = 10; // in mm
        const marginBottom = 10; // in mm
        const usablePdfHeight = pdfHeight - marginTop - marginBottom;

        const imgWidth = canvas.width;
        const imgHeight = canvas.height;

        const ratio = pdfWidth / imgWidth;
        const imgScaledWidth = pdfWidth;
        const imgScaledHeight = imgHeight * ratio;

        let position = 0;

        while (position < imgScaledHeight) {
            const remainingHeight = imgScaledHeight - position;
            const pageHeight = Math.min(remainingHeight, usablePdfHeight);

            const sourceY = position / ratio;
            const sourceHeight = pageHeight / ratio;

            const pageCanvas = document.createElement('canvas');
            pageCanvas.width = canvas.width;
            pageCanvas.height = sourceHeight;

            const ctx = pageCanvas.getContext('2d');
            ctx.drawImage(canvas, 0, sourceY, canvas.width, sourceHeight, 0, 0, canvas.width, sourceHeight);

            const pageData = pageCanvas.toDataURL('image/png');
            if (position > 0) pdf.addPage();
            pdf.addImage(pageData, 'PNG', 0, marginTop, pdfWidth, pageHeight);

            position += pageHeight;
        }

        pdf.save(`${fileName}.pdf`);
    };

    useEffect(() => {
        const downloadFile = async () => {
            if (downloading) {
                await handleDownload(downloading.ref, downloading.name);
                setDownloading(false);
            }
        };

        downloadFile();
    }, [downloading]);



    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        <div className="table-responsive">
                            <table className="table align-middle table-nowrap table-hover">
                                <thead className="table-light">
                                    <tr>
                                        <th scope="col" style={{ width: 70 }}>
                                            ID
                                        </th>
                                        <th scope="col" style={{ width: 70 }}>
                                            REPORT
                                        </th>
                                        <th scope="col">VESSEL</th>
                                        <th scope="col">DATE SUBMITTED </th>
                                        <th scope="col">STATUS </th>
                                        <th scope="col">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {submissions?.length > 0 ? submissions?.map((item, index) => {
                                        const serialNumber = (page - 1) * limit + index + 1;
                                        const refId = `ref-${index}`

                                        return (
                                            <React.Fragment key={item.ID || index}>

                                                <tr>
                                                    <td>{serialNumber}</td>
                                                    <td style={{ color: "#2b5a7e", fontFamily: "nunito" }}>
                                                        Site Query Report Index
                                                    </td>
                                                    <td>
                                                        <p className="text-muted mb-0">
                                                            <span style={{ color: "#ab5858 !important" }}>
                                                                {item.HULL_NUMBER} - {item.SHIP_NAME}
                                                            </span>
                                                        </p>

                                                    </td>
                                                    <td>
                                                        {item.SUBMISSION_DATE ? moment(item.SUBMISSION_DATE).format('DD-MM-YYYY') : 'NA'}
                                                    </td>
                                                    <td>
                                                        {!item.FINAL_SUBMITTED ? 'DRAFT' : 'SUBMITTED'}
                                                    </td>

                                                    <td>
                                                        <ul className="list-inline font-size-20 contact-links mb-0">
                                                            <li className="list-inline-item px-0">
                                                                <Link to={{
                                                                    pathname: constant.Authedcomponent.submitNewBuildingCustomerPropertyInventoryForm.url,
                                                                    state: {
                                                                        data: btoa(JSON.stringify(item)),
                                                                        page: page,
                                                                    },
                                                                }
                                                                }

                                                                    title="Edit Form">
                                                                    <i className="bx bx-edit" />
                                                                </Link>
                                                            </li>
                                                            {item.FINAL_SUBMITTED ? <li className="list-inline-item px-0">
                                                                <a href="#" title="Download PDF"
                                                                    onClick={() =>
                                                                        setDownloading({ ref: refId, name: appendDateRangeToFileName(`CUSTOMER_PROPERTY_INVENTORY_${item.HULL_NUMBER}_${item.SHIP_NAME}_${moment().format('x')}`, parsedFilterPayload) })
                                                                    }
                                                                >
                                                                    <i className="bx bx-download" />
                                                                </a>
                                                            </li> : ''}
                                                            {/* <li className="list-inline-item px-0">
                                                                <a href="#" title="Export Excel"
                                                                    onClick={() => exportBlockInspectionStatus(item.rows, `BlockInspectionStatus_${item.HULL_NUMBER}.xlsx`)}
                                                                >
                                                                    <i className="bx bx-spreadsheet" />
                                                                </a>
                                                            </li> */}

                                                            <DeleteFormAction
                                                                item={item}
                                                                module="siteManagement"
                                                                formCode={FORM_CODE}
                                                                formName={FORM_NAME}
                                                                onDeleted={onDeleted}
                                                            />
                                                        </ul>
                                                    </td>
                                                </tr>

                                            </React.Fragment>
                                        )
                                    })
                                        : <tr>
                                            <td colSpan="7" className="text-center text-muted py-3">
                                                No records found.
                                            </td>
                                        </tr>
                                    }

                                </tbody>
                            </table>
                        </div>

                        {submissions?.length > 0 ? submissions?.map((item, index) => {
                            const serialNumber = (page - 1) * limit + index + 1;
                            const refId = `ref-${index}`

                            return (
                                <React.Fragment key={item.ID || index}>

                                    <div
                                    className={downloading ? '' : 'print-display-none'}
                                    >
                                        <div ref={(el) => (printRefs.current[refId] = el)}
                                            // className='print-only'
                                            id={refId}
                                        >
                                            <Print data={item}
                                                refId={'refId'}
                                            />
                                        </div>
                                    </div>

                                </React.Fragment>
                            )
                        })
                            : ''
                        }
                        <Paginations
                            limit={limit}
                            totalCount={total}
                            range={5}
                            currentPage={page}
                            onPageChange={setPage}
                        />

                    </div>
                </div>
            </div>
        </div >

    )
}

export default List